<template>
<transition name="transition-fade">
  <div class="images-fullscreen modal-backdrop" @click="close()">
    <div class="images-fullscreen-images-wrapper" ref="imagesWrapper" v-scroll-lock="show">
      <div class="images-fullscreen-container" ref="imagesContainer">
        <div class="images-fullscreen-image-wrapper" v-for="(image, index) in images" :key="index" ref="images">
          <img class="images-fullscreen-image" :src="image.url" :style="{ 'max-width': windowWidth + 'px', 'max-height': windowHeight + 'px' }">
        </div>
      </div>
    </div>
    <button class="button-reset images-fullscreen-close-button" type="button">
      <i class="fas fa-times"></i>Stäng
    </button>
  </div>
</transition>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
  name: 'ImagesFullscreen',
  props: ['images', 'startIndex', 'show'],
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      totalImages: this.images.length
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    scrollToImage () {
      let elTarget = this.$refs['images'][this.startIndex]
      let elContainer = this.$refs['imagesWrapper']

      VueScrollTo.scrollTo(elTarget, 500, {
        container: elContainer,
        offset: -16
      })
    },
    getWindowWidth () {
      this.windowWidth = this.$refs.imagesContainer.clientWidth
    },
    getWindowHeight () {
      this.windowHeight = document.documentElement.clientHeight - 80
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.windowWidth = document.documentElement.clientWidth
        this.getWindowHeight()

        this.$nextTick(() => {
          this.scrollToImage()
        })
      }
    }
  },
  mounted () {
    this.totalImages = this.images.length

    window.addEventListener('resize', this.getWindowWidth)
    window.addEventListener('resize', this.getWindowHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_breakpoints.scss';
@import '@/assets/scss/modules/_variables.scss';

.images-fullscreen-container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @include breakpoint-up(1232px) {
    width: 1200px;
  }
}

.images-fullscreen {
  align-items: normal;
}

.images-fullscreen-images-wrapper {
  width: 100%;
  overflow: auto;
  align-items: normal;
  -webkit-overflow-scrolling: touch;
}

.images-fullscreen-image-wrapper {
  padding-bottom: 16px;
  display: block;
}

.images-fullscreen-image-wrapper:first-of-type {
  padding-top: 48px;
}

.images-fullscreen-image {
  max-width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.images-fullscreen-close-button {
  background-color: rgba(0,0,0,0.7);
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  color: #fff;
  padding: 6px 12px;
  position: fixed;
  top: 8px;
  left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.images-fullscreen-close-button .fas {
  margin-right: 8px;
}
</style>
